export const year_grp = [-1, 11, 12];

export const reEnrolment_status = ["Completed", "Synced", "In Progress"];

/** TASS sync state for parent contact records. Bots later set this to synced. */
export const PARENT_RECORD_STATUS = {
    PENDING: 'pending',
    SYNCED: 'synced',
};

export const collegePhoneNumbers = {
        'Adelaide': '(08) 8340 7799',
        'Dianella': '(08) 9375 9770',
        'Forrestdale': '(08) 9493 5819',
        'Henley Brook': '(08) 9375 9892',
        'Kewdale': '(08) 9362 2100',
        'Thornlie': '(08) 9493 2718'
    };